export const _defaultConfigOptions = {
  root: undefined,
  control: undefined,
  target: undefined,
  allTargets: undefined,
  expandable: undefined,
  expanded: undefined,
};
